import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import useStyles from './ShopifySearchBar.styles';

const ShopifySearchBar = ({ query, setQuery, resetPageNumber }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <FontAwesomeIcon icon="search" className="m-2" />
      <input
        className={classes.input}
        type="text"
        value={query}
        placeholder="Search for a product"
        onChange={(e) => {
          setQuery(e.target.value);
          resetPageNumber();
        }}
      />
    </div>
  );
};

export default ShopifySearchBar;
